module.exports = __webpack_public_path__ + "static/img/ai_listen.a8bc25e2.gif";